
//basics
import Vue from 'vue';
import {Component, Watch} from 'vue-property-decorator';
import PazLoader from "../../components/utils/PazLoader.vue";
import {getAllPackageWithSystemApi, getSettings} from "../../services/settings-service";
import {postRequest} from "../../services/auth-service";
import SelectPackage from './SelectPackage.vue';

//extra
import Popup from './Popup.vue';
import FieldContainer from "./FieldContainer.vue";
import PazTooltipButton from "../../components/controls/PazTooltipButton.vue";

@Component({
    components: {
        PazLoader,
        SelectPackage,
        Popup,
        FieldContainer,
        PazTooltipButton,
    }
})

export default class ApiSettingsConfiguration extends Vue {
    public data: object = {};
    public isWelcomePage: boolean = false;
    public isLoading: boolean = false;

    public packages: object[] = [];
    public selectedPackage: string = 'none';
    public packageData: object[] = [];
    public packageDataCopy: object[] = [];
    public tabs: number = 0;
    public messages: object[] = [];
    protected failedFetch: boolean = false;

    //TODO: move from lose var(s) to responseDetail object
    public errorList: object[] = [];
    public successList: object[] = [];
    public showPopup: boolean = false;
    public popup!: {
        color: string,
        code: number,
        message: string
        timeout?: number,
    };

    @Watch('$route', {immediate: true, deep: true})
    private doUrlCheck() {
        if (this.packages.length === 0) {
            return;
        }

        let param: string;
        let inLoop: boolean = false;
        if (this.$route.params.package) {
            param = this.$route.params.package;
            this.packages.forEach((obj: { text: string, id: number|string }) => {
                if (obj.text === param && obj.id !== 0) {
                    inLoop = true;
                }
            })
        }

        if (inLoop) {
            this.selectedPackage = param!;
            return this.fetchOnNewUrl(param!)
        } else {
            return this.setDefault()
        }
    }


    /**
     * Lifecycle function(s)
     */
    mounted() {
        console.log('created settings page')
        this.isLoading = true;
        this.getPackages()
    }


    /**
     * Url checking
     */

    public fetchOnNewUrl(packageName: string) {
        let url = '/apisetting/' + packageName;
        if (url === this.$route.path || (url + '/') === this.$route.path) {
            this.isLoading = true;
            this.clearCurrentPackage();
            this.isWelcomePage = false;
            this.selectedPackage = packageName;
            return this.fetchPackage(packageName)
        }


        this.$router.push(url);
    }

    public checkUrlOnId(id: number|string) {
        let packageName: string = '';

        if (id == 0) {
            return this.setDefault();
        }

        //get package information
        this.packages.forEach((obj) => {
            if (obj.id === id) {
                packageName = obj.text;
            }
        })

        if (!packageName) {
            //go back to default
            this.setDefault()
            return;
        }

        this.fetchOnNewUrl(packageName)
    }


    /**
     * Clear information
     */
    public clearCurrentPackage() {
        this.packageData = [];
        this.packageDataCopy = [];
        this.selectedPackage = 'none';

        //remove all package error(s)/ success states and messages
        this.clearErrorAndSuccess()
    }

    public clearErrorAndSuccess(): void {
        this.errorList = [];
        this.successList = [];
    }

    //reset values back to default
    public setDefault(): void {
        this.isLoading = true;
        this.clearCurrentPackage();
        this.clearErrorAndSuccess();
        this.messages = [];
        this.isLoading = false;
        this.isWelcomePage = true;
    }


    /**
     * Update
     */
    public submitForm() {
        //clear all previous messages and errors/ success
        this.messages = [];
        this.clearErrorAndSuccess();

        //do actual update
        this.doUpateRequest(this.packageData)
    }

    private async doUpateRequest(data: object) {
        let url = 'base/settings-api-packages/' + this.selectedPackage
        let response = (await postRequest(url, data)).data
        response = 'request' in response ? JSON.parse(response.request.response) : response;

        switch (response.status) {
            case 200: {
                this.popup = {
                    color: 'success',
                    code: 200,
                    message: response.message || 'Successfully updated the configuration'
                }
                if ('detail' in response && 'validation' in response.detail) {
                    this.fillValidationList(this.successList, response.detail.validation.success)
                }
                break;
            }
            case 400: {
                this.popup = {
                    color: 'warning',
                    code: 400,
                    message: response.message || 'failed to retrieve  error message. Or none given.',
                }

                //&& 'validation' in response.detail
                if ('validation' in response) {
                    this.fillValidationList(this.errorList, response.validation.error)
                }
                break;

            }
            case 500: {
                this.popup = {
                    color: 'error',
                    code: 500,
                    message: response.exception.message || 'Internal server error. ',
                }
                break;
            }
            default: {
                this.popup = {
                    color: 'error',
                    code: 500,
                    message: response.exception.message || 'Error. ',
                }
                break;
            }
        }

        //always show a popup
        this.showPopup = true;
    }

    fillValidationList(list: object[], fields: any) {
        let ID: string = this.selectedPackage;
        if (Array.isArray(fields)) {
            fields.forEach((key, index) => {
                list.push({
                    key: key.startsWith(ID) ? key : this.selectedPackage + '.' + key,
                })
            })
        } else {
            for (let [key, messages] of Object.entries(fields)) {
                list.push({
                    key: key.startsWith(ID) ? key : this.selectedPackage + '.' + key,
                    ...((typeof messages !== 'undefined' && typeof messages !== 'number') && {message: messages})
                })
            }
        }
    }


    /**
     * Fetch of information
     */


    private statusHandler(status: number, message?: string) {
        switch (status) {
            //configuration error(s)
            case 200: {
                this.popup = {
                    color: 'success',
                    code: 200,
                    message: message ?? 'Successfully completed the task.',
                }
                break;
            }
            case 400: {
                this.popup = {
                    color: 'warning',
                    code: 400,
                    message: 'Fetch of package failed.' + message || '',
                }
                break;
            }

            //internal server error(s)
            case 500: {
                this.popup = {
                    color: 'error',
                    code: 500,
                    message: 'Internal server error. ' + message,
                }
                break;
            }
            default: {
                this.popup = {
                    color: 'error',
                    code: 400,
                    message: 'Unknown response.',
                }
                break;
            }
        }

        this.showPopup = true;
    }

    private async fetchPackage(newPackage: string) {
        let response;
        let message: string;
        let status: number;
        let localFailedStatus: boolean = false;
        this.failedFetch = false;
        try {
            response = await getSettings(newPackage);

            if (typeof response !== 'undefined') {
                status = 200;
                message = 'Successfully fetched package data.';
                this.packageData = response;
            }
        } catch (e) {
            e = 'request' in e ? JSON.parse(e.request.response) : e;
            if (e.status == 400) {
                status = 400;
                message = e.message || e.reason || 'wrongfully configured setup of package.';
            }
            if (e.status == 500) {
                status = 500;
                message = e.exception.message || 'Unknown internal server error. ';
            }

            localFailedStatus = true;
        }


        //handle popup and response status.
        this.statusHandler(status, message)

        this.isLoading = false;


        if (localFailedStatus) {
            this.failedFetch = true;
        }
    }

    generatePath(name: string, path: string): string {
        let newPath: string;
        newPath = path ? path + '.' + name : name;

        return newPath;
    }

    private async getPackages() {
        let data = await getAllPackageWithSystemApi();  //fetch actual data

        //set the initial/ first index of the array of options as:
        this.packages=[];
        this.packages.push({
            'text': 'Select a package',
            'id': 0,
        })

        data.forEach((obj: any) => {
            this.packages.push(obj)
            // data.forEach((obj: { text: string, id: number }, index: number) => {
            //     obj.id = index + 1; //set the index of the new item
            //     if (!obj.hasOwnProperty('id') || obj.hasOwnProperty('text')) {  //check if item has both qualities
            //         return;
            //     }
            //
            //     this.packages.push(obj);
        });

        this.doUrlCheck();  //check if url contains select item
    }


    /**
     * Response handling
     */

    private itemHasChildren(item): boolean {
        return Object.keys(item.children).length > 0 || item.children.length > 0;
    }

    private itemChildrenCount(item) {
        return Object.keys(item.children).length;
    }

    /**
     * Unplaced
     */

    checkForOddCharacters(title: string): string {
        //search and replace all underscores and such
        let newTitle = title.replace(/_/g, "-") //checkt voor nu alleen voor underscores.

        return newTitle;
    }

//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array
//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object
}
